import { useSAudioPlayer_default } from './chunk-5OQTAI6F.mjs';
import { useCountdown } from './chunk-PKGQIOQW.mjs';

// src/universal/hooks/index.ts
var hooks = { useSAudioPlayer: useSAudioPlayer_default, useCountdown };
var hooks_default = hooks;

export { hooks_default };
//# sourceMappingURL=chunk-Z3RTBJ5E.mjs.map
//# sourceMappingURL=chunk-Z3RTBJ5E.mjs.map